import React from "react";
import { Button, FormControl, TextField, Typography } from "@mui/material";
import { notification } from "antd";
import { useFormik } from "formik";
import * as yup from "yup";
import Store from "_Store";
import Container from "../../components/Layout/Container";
import BgAuth from "../../assets/img/bg-auth.png";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { verifyOtp } from "../../services/auth.service";
import { setStorageJson } from "helpers/functions";
import { forgotPassword } from "../../services/auth.service";

export default function OTP() {
  const { setUtils } = React.useContext(Store);
  const navigate = useNavigate();
  const location = useLocation();
  const v = useNavigate()
  const userData = location.state;
  const [error, setError] = React.useState(null);

  const validationSchema = yup.object({
    // userId: yup.string().required("Id valide, réessayer"),
    otp: yup.string().required("Code Invalide"),
  });

  const formik = useFormik({
    initialValues: {
      otp: "",
    },
    validationSchema,
    onSubmit: (v) => {
      verifyOtp({...v, userId : userData.userId})
        .then((res) => res.data)
        .then((res) => {
          if (res.success) {
            setError(null);
            setStorageJson("token", res.data.token);
            navigate("/reset-password");
            setUtils("loading", { spinning: false, primary: "" });
          } else {
            setUtils("loading", { spinning: false, primary: "" });
          }
        })
        .catch((err) => {
          setError(err.response)
          setUtils("loading", { spinning: false, primary: "" });
        });
    },
  });

  return (
    <Container>
      <div className="flex-1 flex pt-12 sm:pt-36">
        <div className="w-full flex justify-center px-4">
          <div className="max-w-[490px] w-full">
            <div className="mb-6">
              <Typography variant="formTitle">
                Code de réinitialisation de mot de passe
              </Typography>

              <div className="flex space-x-10">
                <Typography fontSize={12}>
                  Un code de réinitialisation de votre mot de passe a été envoyé
                  sur votre {userData.resetCodeBy === 'sms' ? 'numéro de téléphone' : "addresse mail"}.
                </Typography>

                <Button
                  disableRipple
                  sx={{
                    fontSize: 12,
                    padding: 0,
                    height: "20px",
                  }}
                  onClick={() => forgotPassword(userData)}
                >
                  <div className="whitespace-nowrap">Renvoyez le code</div>
                </Button>
              </div>
            </div>

            <div>
              <form onSubmit={formik.handleSubmit}>
                <div>
                  <FormControl fullWidth>
                    <TextField
                      size="large"
                      name="otp"
                      label="Code de réinitialisation"
                      type="text"
                      value={formik.values.otp || ""}
                      error={
                        formik.touched.otp && Boolean(formik.errors.otp)
                      }
                      helperText={formik.touched.otp && formik.errors.otp}
                      onChange={formik.handleChange}
                    />
                  </FormControl>
                </div>

                <div className="text-red-500">
                    {error && error.data.message}
                </div>

                <div className="mt-12">
                  <Button
                    size="large"
                    variant="contained"
                    disableElevation
                    color="success"
                    type="submit"
                  >
                    Soumettre
                  </Button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
      <div
        className="sm:w-5/12 bg-cover"
        style={{ backgroundImage: `url(${BgAuth})` }}
      ></div>
    </Container>
  );
}
